import React from "react";
import { useState, useEffect } from "react";

import Navbar from "../../../../components/Navbar";
import SideBar from "../../../../components/SideBar";
import {
  Table,
  InputGroup,
  FormControl,
  Modal,
  Button,
  Form,
  Col,
} from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
import TimePicker from "react-bootstrap-time-picker";
import validate from "./validate";
import { API_URL } from "../../../../constants";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";



const customStyle = {
  control: (provided, state) => ({
    ...provided,
    height: "80px",
    overflow: "scroll",
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: "white", // Sets the color of the cancel icon
    ":hover": {
      backgroundColor: "red", // Adjust hover background color if needed
      color: "white", // Adjust hover color here
    },
  }),
};

function ScheduleInterviewViewPage() {
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(true);
  const [submitted, setSubmit] = useState(false);

  const { interview_id } = useParams();
  let [errors, setErrors] = useState({});
  // dropdowns
  const [jobTitleOpts, setJObTitleOpts] = useState([]);
  const [interviewerOpts, setinterviewerOpts] = useState([]);
  const [roundsOpts, setRoundsOpts] = useState([]);
  const [feedbackOpts, setFeedbackOpts] = useState([]);
  const [mailOpts, setMailOpts] = useState([]);
  const [interviewModeOpt, setMode] = useState([
    { value: "", label: "Select..." },
    { value: "In Person", label: "In Person" },
    { value: "Virtual", label: "Virtual" },
  ]);
  //form data

  const initialFormData = {
    JobMasterID: "",
    JobTitle: "",
    CandidateID: "",
    Interviewee: "",
    InterviewerID: "",
    SecondaryInterviewerIDs: "",
    InterviewMode: "",
    InterviewDate: 36000,
    InterviewTime: "",
    Round: "",
    FeedbackCategory: "",
    IsFinalRound: false,
    ResumePath: "",
    Remark: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  console.log("formData", formData);

  // setting formdata
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      let interviewDetailsUrl = `${API_URL}scheduleinterviews/${interview_id}`;
      let dropDownUrl = `${API_URL}scheduleinterviews`;
      let [interviewDetailsRes, dropdownDetails] = await Promise.all([
        GetServiceCaller(interviewDetailsUrl),
        GetServiceCaller(dropDownUrl),
      ]);
      const jobtitleopts = dropdownDetails?.data?.data?.jobtitle?.map(
        (tech) => ({
          value: tech.value,
          label: tech.text,
        })
      );
      //setting dropdown data
      setJObTitleOpts(jobtitleopts);
      setinterviewerOpts(dropdownDetails?.data?.data?.interviewers);
      setRoundsOpts(dropdownDetails?.data?.data?.rounds);
      setFeedbackOpts(dropdownDetails?.data?.data?.feedback_categories_list);
      setMailOpts(dropdownDetails?.data?.data?.email_template_list);

      interviewDetailsRes = interviewDetailsRes?.data?.data?.headers;

      //setting selected option for dropdown
      let selectedJobDescriptionId = jobtitleopts.find(
        (o) => o.value == interviewDetailsRes.JobMasterID
      );
      let selectedInterviewerId =
        dropdownDetails?.data?.data?.interviewers.find(
          (o) => o.value == interviewDetailsRes.InterviewerID
        );
      let selectedRound = dropdownDetails?.data?.data?.rounds.find(
        (o) => o.value == interviewDetailsRes.Round
      );
      let selectedCategory =
        dropdownDetails?.data?.data?.feedback_categories_list.find(
          (o) => o.value == interviewDetailsRes.FeedbackMasterID
        );

      selectedInterviewerId.label = selectedInterviewerId.text;
      selectedRound.label = selectedRound.text;
      selectedCategory.label = selectedCategory.text;
      let selectedInterviewMode = interviewModeOpt.find(
        (o) => o.value == interviewDetailsRes.Location
      );
      let interviewFormData = {
        JobMasterID: selectedJobDescriptionId,
        CandidateID: interviewDetailsRes.CandidateID,
        Interviewee: interviewDetailsRes.interviewee,
        InterviewerID: selectedInterviewerId,
        SecondaryInterviewerIDs: interviewDetailsRes?.SecondaryInterviewerIDs,
        InterviewMode: selectedInterviewMode,
        InterviewDate: moment(interviewDetailsRes.InterviewDate).format(
          "DD-MMM-YYYY"
        ),
        InterviewTime: interviewDetailsRes.OldInterviewTime,
        InterviewToTime: interviewDetailsRes?.InterviewEndTime,

        Round: selectedRound,
        FeedbackCategory: selectedCategory,
        IsFinalRound: interviewDetailsRes.IsFinalRound ? true : false,
        ResumePath: interviewDetailsRes.ResumePath,
        ResumeBasePath: interviewDetailsRes.ResumeBasePath,
        Remark: interviewDetailsRes.Remark,
      };
      setFormData(interviewFormData);
      setFormData(interviewFormData);

      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching course details:", error);
    }
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Schedule Interview Details"));
  }, []);

  const intervieweropts = interviewerOpts?.map((tech) => ({
    value: tech.value,
    label: tech.text,
  }));

  intervieweropts.unshift({ value: "", label: "Select..." });

  const roundopts = roundsOpts?.map((tech) => ({
    value: tech.value,
    label: tech.text,
  }));
  roundopts.unshift({
    value: "",
    label: "Select...",
  });
  const feedbackopts = feedbackOpts?.map((tech) => ({
    value: tech.value,
    label: tech.text,
  }));
  feedbackopts.unshift({
    value: "",
    label: "Select...",
  });
  const mailopts = mailOpts?.map((tech) => ({
    value: tech.value,
    label: tech.text,
  }));

  const handleDateChange = (date, name) => {
    setFormData({ ...formData, [name]: moment(date).format("DD-MMM-YYYY") });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleDropdownChange = (selected, name) => {
    setFormData({ ...formData, [name]: selected });
  };
  const handleTimeChange = (time) => {
    setFormData({ ...formData, InterviewTime: time });
  };
  const handleCheckBoxChange = (e) => {
    setFormData({ ...formData, IsFinalRound: !formData.IsFinalRound });
  };
  const handleOnTouch = async (e) => {
    const { name, value } = e.target;
    let error = await validate(name, value, formData);
    setErrors((errors) => ({
      ...errors,
      [name]: error,
    }));
  };
  const handleSubmit = async (e) => {
    let mandatory_field = [
      "JobMasterID",
      "Interviewee",
      "InterviewerID",
      "InterviewDate",
      "InterviewTime",
      "InterviewMode",
      "Round",
      "FeedbackCategory",
    ];
    let isFormInvalid = false;
    for (let field of mandatory_field) {
      let error = validate([field], formData[field], formData);

      if (error.status == true) {
        isFormInvalid = true;
      }
      setErrors((errors) => ({
        ...errors,
        [field]: error,
      }));
    }

    if (!isFormInvalid) {
      try {
        setSubmit(true);
        let data = formData;
        data.FeedbackCategory = formData.FeedbackCategory;
        data.InterviewerID = formData.InterviewerID;
        data.JobMasterID = formData.JobMasterID;
        data.Round = formData.Round;
        data.IntervieweeMailTemplateID = mailOpts[0].value;
        data.InterviewerMailTemplateID = mailOpts[1].value;
        data.SchedularMailTemplateID = mailOpts[1].value;

        let response;
        /* response = await PostServiceCaller(`${API_URL}scheduleinterviews/${interview_id}`, data,'put');
        if (response.data.status == 'success') {
          toast.success(response.data.message);
          setSubmit(false);
         naviage('/schedule-interview-list');
        } else {
          setSubmit(false);
          toast.error(response.data.message);
        } */
      } catch (error) {
        setSubmit(false);
        console.error("Error submitting form data:", error);
      }
    }
  };
  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="Container">
          <form id="formOne" className="rounded mt-2 bg-white">
            <div className="row">
              <div className="col-sm-3">
                <Form.Group>
                  <label className="form-label">
                    Job Title<span class="required">*</span>
                  </label>
                  <Select
                    value={formData.JobMasterID}
                    onBlur={handleOnTouch}
                    name="JobMasterID"
                    onChange={(selected) =>
                      handleDropdownChange(selected, "JobMasterID")
                    }
                    class="form-control"
                    options={[
                      { value: "", label: "Select..." },
                      ...jobTitleOpts,
                    ]}
                    required
                    isDisabled={true}
                  />
                  <span class="error">{errors?.JobMasterID?.message}</span>
                </Form.Group>
              </div>
              <div className="col-sm-3">
                <Form.Group>
                  <label className="form-label">
                    Interviewee<span class="required">*</span>
                  </label>
                  <Form.Control
                    onChange={handleChange}
                    onBlur={handleOnTouch}
                    type="text"
                    placeholder=""
                    name="Interviewee"
                    value={formData.Interviewee}
                    disabled
                  />
                  <span class="error">{errors?.Interviewee?.message}</span>
                </Form.Group>
              </div>
              <div className="col-sm-3">
                <Form.Group>
                  <label className="form-label">
                    Interviewer<span class="required">*</span>
                  </label>
                  <Select
                    value={formData.InterviewerID}
                    name="InterviewerID"
                    onChange={(selected) =>
                      handleDropdownChange(selected, "InterviewerID")
                    }
                    options={intervieweropts}
                    class="form-control"
                    isDisabled={true}
                  />
                  <span class="error">{errors?.InterviewerID?.message}</span>
                </Form.Group>
              </div>
              <div className="col-md-6 col-lg-3">
                <label className="form-label">
                  Secondary Interviewer
                </label>
                <Select
                  name="SecondaryInterviewerIDs"
                  value={
                    intervieweropts.filter(opt =>
                      formData.SecondaryInterviewerIDs?.split(",").includes(String(opt.value))
                    )
                  }
                  onChange={(selected) =>
                    handleDropdownChange(
                      selected ? selected.map(item => item.value).join(",") : "",
                      "SecondaryInterviewerIDs"
                    )
                  }
                  styles={customStyle}
                  menuShouldScrollIntoView={true}
                  isMulti
                  options={[
                    { value: "", label: "Select...", isDisabled: true },
                    ...intervieweropts,
                  ]}
                  isDisabled
                />

                {errors?.SecondaryInterviewerIDs?.status && (
                  <span class="error">{errors?.SecondaryInterviewerIDs?.message}</span>
                )}
              </div>

            </div>
            {/* SecondRow */}
            <div className="row">
              <div className="col-sm-3">
                <Form.Group>
                  <label className="form-label">
                    Interview Mode <span className="required">*</span>
                  </label>
                  <Select
                    name="InterviewMode"
                    value={formData.InterviewMode}
                    onChange={(selected) =>
                      handleDropdownChange(selected, "InterviewMode")
                    }
                    options={interviewModeOpt}
                    isDisabled={true}
                  />
                  <span class="error">{errors?.InterviewMode?.message}</span>
                </Form.Group>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label">
                    Interview Date<span class="required">*</span>
                  </label>
                  <ReactDatePicker
                    onBlur={handleOnTouch}
                    minDate={new Date()}
                    showYearDropdown
                    showPopperArrow
                    showIcon
                    icon="fa fa-calendar"
                    className="form-control"
                    placeholderText="From Date"
                    format="DD-MMM-YYYY"
                    name="InterviewDate"
                    id="InterviewDate"
                    onChange={(date) => handleDateChange(date, "InterviewDate")}
                    value={formData.InterviewDate}
                    disabled
                  />
                  <span class="error">{errors?.InterviewDate?.message}</span>
                </div>
              </div>
              <div className="col-sm-3">
                <Form.Group>
                  <label className="form-label">
                    Interview Start Time<span class="required">*</span>
                  </label>
                  <TimePicker
                    disabled

                    name="InterviewTime"
                    value={formData.InterviewTime}  // Now in "HH:mm:ss" format

                    step={15}
                    onChange={(e) => handleTimeChange(e, "InterviewTime")}
                  />

                  <span class="error">{errors?.InterviewTime?.message}</span>
                </Form.Group>
              </div>
              <div className="col-md-6 col-lg-3">
                <label className="form-label">
                  Interview End Time<span class="required">*</span>
                </label>
                <TimePicker
                  disabled

                  name="InterviewToTime"
                  value={formData.InterviewToTime}  // Now in "HH:mm:ss" format

                  step={15}
                  onChange={(e) => handleTimeChange(e, "InterviewToTime")}
                />

                {errors?.InterviewToTime?.status && (
                  <span class="error">{errors?.InterviewToTime?.message}</span>
                )}
              </div>

            </div>
            {/* ThirdRow */}
            <div className="row">
              <div className="col-sm-3">
                <Form.Group>
                  <label className="form-label">Interviewee Mail Template<span class='required'>*</span></label>
                  <input
                    className="form-control"
                    options={mailopts}
                    isDisabled={false}
                    name="intervieweeMailTemplate"
                    value={mailOpts?.[1]?.text}
                    disabled
                  />

                </Form.Group>
              </div>
              <div className="col-sm-3">
                <Form.Group  >
                  <Form.Label>Interviewer Mail Template<span class='required'>*</span></Form.Label>
                  <input
                    className="form-control"
                    options={mailopts}
                    name="interviewerMailTemplate"
                    value={mailOpts?.[2]?.text}
                    disabled
                  />
                </Form.Group>
              </div>
              <div className="col-sm-3">
                <Form.Group>
                  <Form.Label>Scheduler Mail Template<span class='required'>*</span></Form.Label>
                  <input
                    className="form-control"
                    options={mailopts}
                    isDisabled={true}
                    name="ScheduleMailTemplate"
                    // onChange={formik.handleChange}
                    disabled
                    value={mailOpts?.[2]?.text}
                    required
                  />
                </Form.Group>
              </div>
              <div className="col-sm-3">
                <Form.Group>
                  <label className="form-label">
                    Round<span class="required">*</span>
                  </label>
                  <Select
                    options={roundopts}
                    isDisabled={true}
                    name="Round"
                    value={formData.Round}
                    onChange={(selected) =>
                      handleDropdownChange(selected, "Round")
                    }
                  />
                  <span class="error">{errors?.Round?.message}</span>
                </Form.Group>
              </div>
            </div>
            {/* FourthRow */}
            <div className="row ">

              <div className="col-sm-3">
                <Form.Group>
                  <label className="form-label">
                    Feedback Category<span className="required">*</span>
                  </label>
                  <Select
                    options={feedbackopts}
                    isDisabled={true}
                    name="FeedbackCategory"
                    value={formData.FeedbackCategory}
                    onChange={(selected) => {
                      handleDropdownChange(selected, "FeedbackCategory");
                    }}
                  />
                  <span class="error">{errors?.FeedbackCategory?.message}</span>
                </Form.Group>
              </div>
              <div className="col-sm-3">
                <Form.Group>
                  <Form.Label> Remark </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="Remark"
                    value={formData.Remark}
                    onChange={handleChange}
                    disabled
                  ></Form.Control>
                </Form.Group>
              </div>
              <div className="col-sm-3 mt-4">
                <div className="form-check">
                  <label className="form-check-label">Is Final Round </label>
                  <input
                    onChange={handleCheckBoxChange}
                    className="form-check-input"
                    type="checkbox"
                    name="IsFinalRound"
                    checked={formData.IsFinalRound}
                    disabled
                  />
                </div>
              </div>
              <div className="col-sm-3">
                <strong>Resume</strong>
                <br />
                <p>
                  <a href={formData.ResumeBasePath} target="_blank">
                    {formData.ResumePath ? formData.ResumePath : ""}
                  </a>
                </p>
              </div>
            </div>

            <div className="row mt-3">
              <div className="text-end ">
                <button
                  className="cancel-btn me-2"
                  onClick={() => navigate("/schedule-interview-list")}
                >
                  Back
                </button>
                {/* <button type="submit" disabled={submitted ? true : false} onClick={handleSubmit} className="custom-btn">{submitted ? <FaSpinner class="sm-spinner" /> : 'Submit'}</button> */}
              </div>
            </div>

          </form>

        </div>
      </>
    );
  }
}

export default ScheduleInterviewViewPage;
